import { render, staticRenderFns } from "./RecordRevisionsConfigurator.vue?vue&type=template&id=348faab0&scoped=true&"
import script from "./RecordRevisionsConfigurator.vue?vue&type=script&lang=js&"
export * from "./RecordRevisionsConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./RecordRevisionsConfigurator.vue?vue&type=style&index=0&id=348faab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348faab0",
  null
  
)

export default component.exports